module.exports = __webpack_public_path__ + "img/menu_heart.259603bf.svg";